import { render, staticRenderFns } from "./MilestoneTabs.vue?vue&type=template&id=57e8049c&"
import script from "./MilestoneTabs.vue?vue&type=script&lang=js&"
export * from "./MilestoneTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports